const HeadBanner = ({imageUrl}) => {
    return(
        <img src={imageUrl} width="100%" style={{marginBottom: "16px"}} />
    )
}

export default HeadBanner;